import React from "react";
import * as actions from './Actions';
import Service from '../../service/Service';
import YouTube from 'react-youtube';
import ShareOptions from './ShareOptions';
import { Link } from "react-router-dom";
const service = new Service();

export default function VideoSection ({videoData, eleRef}){
    // var eleRef = videoData.eleRef;
    // var videoData = videoData.videoData;
    return(
        <section className="videos-section">
            <div className="section-title">VIDEOS</div>
            {videoData.video.map((video, i3) => 
            <div key={i3} className="videos_container">
                <div className="video_block" data-id={video.videoId}>
                    {video.url &&
                        <YouTube videoId={video.url.split('=')[1]} height={eleRef.state.videoHeight} width={eleRef.state.videoWidth} onStateChange={(e) => actions.onPlayerStateChange(e, video.videoId, eleRef)} />
                    }
                    <div className="video_details" id={`videodet-${video.videoId}`}>
                        <span className="M14_white">#{video.keyword}</span>
                        <span className="M19_white">{video.videoTitle.replace('â€™', "&#39;")}</span>
                    </div>
                </div>
                <div className="view_details">
                    <span className="left social_activities">
                        <span className="icon" data-icon-font="$"></span>
                        <span className="R11_9e">{service.intToString(video.viewCount)} Views</span>
                    </span>
                    <span className="social_activities likeactivity">
                        <span className={video.isLike ? "icon likeicon isliked" : "icon likeicon"} data-icon-font="&#xe020;" onClick={() => actions.saveVideoAction(video.videoId, "like", video.isLike ? 0 : 1, eleRef)}></span>
                        <span className="R11_9e">{service.intToString(video.likeCount)} Likes</span>
                    </span>
                    {/* <div className="card-share social-actions" id={`share_${video.videoId}`}>
                        <span className="R14_9e left share-icon share-click" onClick={() => actions.shareOn(video.videoId)}>
                            <div data-icon-font="" className="icon left share-click"></div>
                            <div data-icon-font="" className="icon left share-click"></div>
                            <div className="R14_9e left share-click share-vtext">Share</div>
                        </span>
                        <ShareOptions data={video} eleRef={this} />
                    </div> */}
                    <div className="right share-action" id={`share_${video.videoId}`} onClick={() => actions.shareOn(video.videoId)}>
                        <span className="share-ic share-click">
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook-icon.png" alt="Facebook" title="Facebook" />
                        </span>
                        <span className="share-ic whtap-icon share-click" data-icon-font="&#xe019;"></span>
                        <span className="action-text right share-click">Share</span>
                        <ShareOptions data={video} eleRef={this} />
                    </div>
                </div>
                {/* <div className="share-overlay"></div> */}
            </div>
            )}
            {videoData.search_cnt > videoData.video.length &&
            <div className="moreResults dev_v_all" title="VIDEOS" onClick={()=>eleRef.getMoreSearchData(videoData.type)}>SEE MORE RESULTS</div>
            }
        </section>
    );
}
